import { c as _c } from "react/compiler-runtime";
import ServiceCard from './service-card';
import { packages, recommendedPackage } from './service-data';
import HalfLayout from '@/components/layouts/half-layout';
const ServiceLayout = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HalfLayout.LeftChild><section className="ml-auto flex origin-right flex-col gap-9">{packages.map(_temp)}</section></HalfLayout.LeftChild>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HalfLayout className="gap-7.5">{t0}<HalfLayout.RightChild><div className="sticky top-20"><ServiceCard {...recommendedPackage} recommended={true} /></div></HalfLayout.RightChild></HalfLayout>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ServiceLayout;
function _temp(pkg, idx) {
  return <ServiceCard {...pkg} key={pkg.id} index={idx} className="ml-auto" />;
}